import { Input } from 'antd';
import React from 'react';
import {
  TemplateNamesByValueByVariable,
  VariableModel,
} from '../../iasConfigSchema';
import VariableFormItem from '../variables/VariableFormItem';

const DefaultWidget: React.FC<{
  variable: VariableModel;
  disabled: boolean;
  templateName: string;
  usedUniqueValues: TemplateNamesByValueByVariable;
}> = ({ variable, disabled, templateName, usedUniqueValues }) => {
  return (
    <VariableFormItem
      variable={variable}
      templateName={templateName}
      usedUniqueValues={usedUniqueValues}
    >
      <Input disabled={disabled} />
    </VariableFormItem>
  );
};

export default DefaultWidget;
